import { deleteDoc, doc, setDoc, updateDoc } from "firebase/firestore";
import { deleteApprovedTestimonies, getApprovedTestimonies, initDB, saveApprovedTestimonies } from "../ConfigureIndexedDB";
import TextShortener from "../TextShortener";
import db, { storage } from "../Backend";
import { useEffect, useState } from "react";
import { deleteObject, ref } from "firebase/storage";


const Testimonycontent = ({username,user_unit,user_chapter,testimony,displaypic,dateSent,year,timestamp,senderID}) => {
        const [postIDapproved,setPostIDapproved]=useState("");
        const [isApproved,setApproved]=useState(false);
        const [showEdittextBox,setshowEdittextBox]=useState(false);
        const [editedText,setEditedText]=useState("");

        const approvePost=async(e)=>{
            if(e.target.checked){
                try{
                    await setDoc(doc(db,"testimonyApproved",senderID),{
                        username,
                        user_unit,
                        user_chapter,
                        testimony,
                        displaypic,
                        year,
                        senderID,
                        dateSent,
                        timestamp 
                     });
                     
                     initDB().then(()=>{
                        saveApprovedTestimonies({
                            id: senderID,
                            username,
                            user_unit,
                            user_chapter,
                            testimony,
                            displaypic,
                            year,
                            senderID,
                            dateSent,
                            timestamp
                        }).then(()=>{
                            setApproved(true);
                        })
                        .catch((err)=>{
                            console.log(err);
                        });
                     }).catch((err)=>{
                        console.log(err);
                     });
                }catch{

                }
            }
        };

        useEffect(()=>{
            initDB().then(()=>{
                getApprovedTestimonies(senderID).then((data)=>{
                    if(data){
                        setPostIDapproved(data.senderID);
                    }
                }).catch((err)=>{
                    console.log(err);
                });
            }).catch((err)=>{
                console.log(err);
            });

            if(senderID === postIDapproved){
                setApproved(true);
            }
        },[postIDapproved,senderID]);

        const deactivatepost=async(e)=>{
            if(e.target.checked){
                try{
                    await deleteDoc(doc(db,"testimonyApproved",senderID));
                    initDB().then(()=>{
                        deleteApprovedTestimonies(senderID)
                        .then((res)=>{
                            if(res === true){
                                setApproved(false);
                            }
                        }).catch((err)=>{
                            console.log(err);
                        })
                    }).catch((err)=>{
                        console.log(err);
                    });
                
                }catch{

                }
            }
        };

        const TerminatePost=async(e)=>{
            if(e.target.checked){
                try{
                    await deleteDoc(doc(db,"testimonyApproved",senderID),{
                        username,
                        user_unit,
                        user_chapter,
                        testimony,
                        displaypic,
                        year,
                        senderID,
                        dateSent,
                        timestamp 
                    });
                    await deleteDoc(doc(db,"testimonyReview",senderID),{
                        username,
                        user_unit,
                        user_chapter,
                        testimony,
                        displaypic,
                        year,
                        senderID,
                        dateSent,
                        timestamp 
                    });
                    deleteObject(ref(storage,`testifierpic/${username+senderID}`))
                    .then(()=>{
                        console.log("deleted image");
                    })
                    .catch((err)=>{
                        
                    });
                    setApproved(false);
                }catch{

                }
            };
        };

        const handleEditPost=()=>{
            setEditedText(testimony);
            setshowEdittextBox(true);
        };
    
        const handleUpdatePost=async(docid)=>{
            await updateDoc(doc(db,"testimonyReview",docid),{
              testimony: editedText
            });
            setshowEdittextBox(false);
            setEditedText("");
        };
        const handleCancelEditing=()=>{
          setshowEdittextBox(false);
          setEditedText("");
        };



    return ( 
        <div className="testimonycontent flex-column1" key={timestamp}>
            <div className="tchead flex-spacebetween" style={{width:"100%"}}>
                <div className="testifierinfo flex-row2">
                    {displaypic && displaypic !== null && displaypic !=="" ?
                    <img src={displaypic} alt=""/>
                    :
                    <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="30px"
                    width="30px" >
                    <path d="M12 2A10.13 10.13 0 002 12a10 10 0 004 7.92V20h.1a9.7 9.7 0 0011.8 0h.1v-.08A10 10 0 0022 12 10.13 10.13 0 0012 2zM8.07 18.93A3 3 0 0111 16.57h2a3 3 0 012.93 2.36 7.75 7.75 0 01-7.86 0zm9.54-1.29A5 5 0 0013 14.57h-2a5 5 0 00-4.61 3.07A8 8 0 014 12a8.1 8.1 0 018-8 8.1 8.1 0 018 8 8 8 0 01-2.39 5.64z" />
                    <path d="M12 6a3.91 3.91 0 00-4 4 3.91 3.91 0 004 4 3.91 3.91 0 004-4 3.91 3.91 0 00-4-4zm0 6a1.91 1.91 0 01-2-2 1.91 1.91 0 012-2 1.91 1.91 0 012 2 1.91 1.91 0 01-2 2z" />
                    </svg>
                    }

                    <div className="flex-column2">
                        <h4>{username && username}</h4>
                        <p>{dateSent}</p>
                    </div>
                </div>

                <p>Unit: {user_unit && user_unit}</p>
                <p>Chapter: {user_chapter && user_chapter}</p>
                <p>Year: {year}</p>
            </div>

            <div className="tctext" style={{width:"100%"}}>
                    {testimony && <TextShortener fullText={testimony} words={200} />}
            </div>

            <div className="tcfooter flex-spacebetween" style={{width:"100%"}}>
                    <div className='tccommenttrigger flex-column2' style={{position:"relative"}}>
                                <button onClick={()=>handleEditPost()}
                                style={{
                                border:"none",
                                backgroundColor:"transparent",
                                cursor:"pointer",
                                fontWeight:"bold"
                            }}>
                                Edit
                            </button>

                            {showEdittextBox && 
                            <div className="editingarea flex-column2">
                                    <h3 style={{color:"white"}}>Edit Text</h3>
                                    <textarea rows={15} value={editedText} onChange={e => setEditedText(e.target.value)}/>
                                    <div className="flex-row2" style={{gap:"5px"}}>
                                    <button onClick={() => handleUpdatePost(senderID)}>Amend</button>
                                    <button onClick={()=>handleCancelEditing()}>Exit Editing</button>
                                    </div>
                                
                            </div>
                            }
                    </div>
                    
                    {isApproved && 
                       <div className="flex-row2">
                       <input id={`deactivatepost${timestamp}`} type="checkbox" onChange={deactivatepost} />
                       <label htmlFor={`deactivatepost${timestamp}`}>Deactivate</label>
                    </div>
                    }

                    {isApproved && 
                       <div className="flex-row2" >
                       <input id={`deletepost${timestamp}`} type="checkbox" onChange={TerminatePost} />
                       <label htmlFor={`deletepost${timestamp}`}>Terminate</label>
                    </div>
                    }
                 
                    {!isApproved ? 
                        <div className="flex-row2">
                            <input id={`approvepost${timestamp}`} type="checkbox" onChange={approvePost} />
                            <label htmlFor={`approvepost${timestamp}`}>Approve</label>
                        </div>
                        :
                        <div className="flex-row2">
                               <svg
                                viewBox="0 0 24 24"
                                fill="#128C7E"
                                height="1.2em"
                                width="1.2em">
                                <path d="M4.035 15.479A3.976 3.976 0 004 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479zm1.442-5.403l1.102-.293-.434-1.053A1.932 1.932 0 016 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 013.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 010 3.848l-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 01-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 018 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 010-3.848z" />
                                <path d="M15.742 10.71l-1.408-1.42-3.331 3.299-1.296-1.296-1.414 1.414 2.704 2.704z" />
                                </svg>
                                <p>Live Mode</p>
                        </div>
                    }
                    
                   
            </div>
        </div>
     );
}
export default Testimonycontent;